import React, { useState, useEffect } from 'react';

function TabPrezzi({prodotto}) {

    const [mostraAcquisto,setMostraAcquisto] = useState(false);

    const datiProd = prodotto[0]

    return(
        <div>
            <div className='mt3 f5 ttu b tc'>Listini</div>
            <div className='flex justify-between b f5 mt4'>
                <div className='w-25'>LISTINO</div>
                <div className='w-25'>INTERO</div>
                <div className='w-25'>SCONTO</div>
                <div className='w-25'>NETTO</div>
            </div>
            {mostraAcquisto && 
            <div className='flex justify-between f5 mt3'>
                <div className='w-25 f6'>ACQUISTO</div>
                <div className='w-25'>€{datiProd.acq_listino}</div>
                <div className='w-25'>{datiProd.acq_sc1+datiProd.acq_sc2+datiProd.acq_sc3+datiProd.acq_sc4}%</div>
                <div className='w-25 b'>€{datiProd.acq_netto}</div>
            </div>}
            <div className='flex justify-between f5 mt3'>
                <div className='w-25 f6'>TORINO</div>
                <div className='w-25'>€{datiProd.torino_listino}</div>
                <div className='w-25'>{datiProd.torino_sc1}%</div>
                <div className='w-25 b'>€{datiProd.torino_netto}</div>
            </div>
            <div className='flex justify-between f5 mt3'>
                <div className='w-25 f6'>PRATO</div>
                <div className='w-25'>€{datiProd.prato_listino}</div>
                <div className='w-25'>{datiProd.prato_sc1}%</div>
                <div className='w-25 b'>€{datiProd.prato_netto}</div>
            </div>
            <div className='flex justify-between f5 mt3'>
                <div className='w-25 f6'>WEB</div>
                <div className='w-25'>€{datiProd.web_listino}</div>
                <div className='w-25'>{datiProd.web_sc1}%</div>
                <div className='w-25 b'>€{datiProd.web_netto}</div>
            </div>
            <div className='tc'>
            {mostraAcquisto?
                <div className="material-icons scrittaColoreAltScuro mt4"
                onClick={()=>setMostraAcquisto(false)}
                >visibility_off</div>
            :   <div className="material-icons scrittaColoreAltScuro mt4"
                onClick={()=>setMostraAcquisto(true)}
                >visibility</div>
            }
            </div>
        </div>
    )
}

export default TabPrezzi;